/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Admin API
 * OpenAPI spec version: 0.1.1
 */

/**
 * The kind of Metabase resource an embed is signed for. The string values (`Dashboard`, `Question`)
 * are part of Metabase's own embedding payload, so they must stay exactly as they are.
 */
export type MetabaseResourceType = typeof MetabaseResourceType[keyof typeof MetabaseResourceType];


export const MetabaseResourceType = {
  Dashboard: 'Dashboard',
  Question: 'Question',
} as const;
